import { secondsToFrame } from 'utils/media-time';

export type TranscriptCheckpointMode = 'phase2a' | 'phase2b';

interface CheckpointOptions {
    mode: TranscriptCheckpointMode;
    transcriptData: any;
    people: any[];
    startFrame: number;
    stopFrame: number;
    frameRate: number;
}

function firstUtteranceEnd(transcriptData: any, serverIDs: string[]): number {
    return transcriptData?.segments?.find((segment: any) => {
        if (!segment?.speaker) {
            return false;
        }

        const [, , serverID] = segment.speaker.split('_');
        return serverIDs.includes(serverID);
    })?.end || 0;
}

export function computeTranscriptCheckpointFrames(options: CheckpointOptions): number[] {
    const {
        mode,
        transcriptData,
        people,
        startFrame,
        stopFrame,
        frameRate,
    } = options;

    if (!transcriptData) {
        return [];
    }

    const civilianServerIDs = people
        .filter(
            (state) => (
                state.label.name.startsWith('person:Civilian') &&
                !state.label.name.startsWith('person:Civilian:Bystander')
            ),
        )
        .map((state) => `${state.serverID}`);
    const policeServerIDs = people
        .filter((state) => state.label.name.startsWith('person:Police'))
        .map((state) => `${state.serverID}`);
    const firstSharedContextEnd = Math.max(
        firstUtteranceEnd(transcriptData, civilianServerIDs),
        firstUtteranceEnd(transcriptData, policeServerIDs),
    );

    const firstCheckpoint = Math.round(Math.min(
        secondsToFrame(
            firstSharedContextEnd + 60,
            startFrame,
            stopFrame,
            frameRate,
        ),
        Math.max(startFrame, stopFrame - Math.ceil(frameRate * 60)),
    ));

    if (mode === 'phase2a') {
        return [
            firstCheckpoint,
            Math.floor((firstCheckpoint + (stopFrame - 1)) / 2),
            stopFrame - 1,
        ];
    }

    const checkpoints = [firstCheckpoint];
    while (checkpoints[checkpoints.length - 1] + 30 * frameRate < stopFrame) {
        checkpoints.push(Math.floor(checkpoints[checkpoints.length - 1] + 30 * frameRate));
    }
    checkpoints.push(stopFrame - 1);
    return checkpoints;
}
